// @ts-check
/**
 * @param {Element} element
 */
const handleNotificationBlock = (element) => {

    /** @type {HTMLButtonElement | null} */
    const notificationClose = element.querySelector("button.notification-block-close");

    // If the notification has a button, bind the closing event
    if (notificationClose) {
        notificationClose.addEventListener("click", () => {
            element.classList.toggle("hidden", true);
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const notificationBlocks = document.querySelectorAll(".notification-block");
    if (notificationBlocks.length > 0) {
        notificationBlocks.forEach((element) => handleNotificationBlock(element));
    }
});